function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m160.026 65.82 85.83 36.24 4.533-101.026-4.532 1.866-85.7 35.23c-12.292 5.048-12.412 22.495-.131 27.69z",
  fill: "#db1f79"
}), /*#__PURE__*/React.createElement("path", {
  d: "m90.857 364h155v-267.18c-2.587 2.322 8.729-13.229-167.38 243.71-6.784 9.915.304 23.47 12.38 23.47z",
  fill: "#f0faff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m265.857 137.43c46.508 51.685 46.997 129.954 0 182.18v44.39h155c8.28 0 15-6.72 15-15 0-45.43-9.19-87.15-27.32-124.01-29.988-60.965-85.651-107.796-142.68-129.35z",
  fill: "#cee6f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m240.857 15v382h30v-382c0-8.28-6.72-15-15-15s-15 6.72-15 15z",
  fill: "#823931"
}), /*#__PURE__*/React.createElement("path", {
  d: "m270.86 15v382h-15v-397c8.28 0 15 6.72 15 15z",
  fill: "#583227"
}), /*#__PURE__*/React.createElement("path", {
  d: "m488.646 391.57h-465c-9.171 0-16.207 8.174-14.83 17.25l13.72 90.43c1.112 7.332 7.415 12.75 14.83 12.75h335.297c61.246 0 116.016-41.209 130.571-101.938 1.069-4.466-4.884-18.492-14.588-18.492z",
  fill: "#ac5743"
}), /*#__PURE__*/React.createElement("path", {
  d: "m488.646 391.57h-465c-9.171 0-16.207 8.174-14.83 17.25l13.72 90.43c1.112 7.332 7.415 12.75 14.83 12.75h335.297c61.246 0 116.016-41.209 130.571-101.938 1.069-4.466-4.884-18.492-14.588-18.492z",
  fill: "#ac5743"
}), /*#__PURE__*/React.createElement("path", {
  d: "m503.23 410.06c-14.55 60.73-69.32 101.94-130.57 101.94h-116.8v-120.43h232.79c9.7 0 15.65 14.03 14.58 18.49z",
  fill: "#823931"
}));

var SvgSailboat = function SvgSailboat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSailboat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sailboat.c8a9cfda.svg";
export { ForwardRef as ReactComponent };